import React, { Component, createRef } from 'react'
import T from 'prop-types'
import * as ROUTE from 'constants/appRouting'
import Notice from 'components/common/Notice/Notice'
import NoInternetLoader from 'components/Loading/NoInternetLoader'
import { getProfileItemRoleLevel } from 'helpers/menuProfile'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import Sidenav from './Sidenav'
import { Header } from './Header'
import HeaderOld from './HeaderOld'
import Footer from './Footer'
import 'styles/app/customize.scss'

class AppLayout extends Component {
  isOpenMenu = createRef()

  constructor(props) {
    super(props)

    this.state = {
      isOffline: false,
    }
  }

  componentDidMount() {
    window.addEventListener('online', () => this.setIsOffline(false))
    window.addEventListener('offline', () => this.setIsOffline(true))
  }

  setIsOffline = value => {
    this.setState({
      isOffline: value,
    })
  }

  onMobileMenuToggle = () => {
    this.isOpenMenu.current.classList.toggle('mobile-menu-open')
  }

  onHideMenu = () => {
    this.isOpenMenu.current.classList.remove('mobile-menu-open')
  }

  render() {
    const { isOffline } = this.state
    const {
      children,
      role,
      roleLevel,
      history,
      locationPath,
      isAccessDenied,
      allowedToManageWorkflows,
      featureFlags,
    } = this.props

    return (
      <div className="main-app-container" ref={this.isOpenMenu}>
        <NoInternetLoader loading={isOffline} />
        <Notice />
        <Sidenav
          hideMenu={this.onHideMenu}
          toggleMobileMenu={this.onMobileMenuToggle}
        />
        {featureFlags.APP_HEADER_V2 ? (
          <Header
            onClick={this.onMobileMenuToggle}
            locationPath={locationPath}
          />
        ) : (
          <HeaderOld onClick={this.onMobileMenuToggle} />
        )}
        <section id="page-container" className="app-page-container">
          <div className="app-content-wrapper">
            <div className="app-content">
              <div className="content-container">
                {(roleLevel >= role &&
                  roleLevel >= getProfileItemRoleLevel(locationPath) &&
                  !isAccessDenied) ||
                (locationPath === ROUTE.JOBS_WORKFLOW_ADMIN &&
                  allowedToManageWorkflows)
                  ? children
                  : history.replace(ROUTE.ERROR_403)}
              </div>
            </div>
            <Footer />
          </div>
        </section>
      </div>
    )
  }
}

AppLayout.propTypes = {
  children: T.node.isRequired,
  history: T.object.isRequired,
  roleLevel: T.number.isRequired,
  role: T.number.isRequired,
  locationPath: T.string.isRequired,
  isAccessDenied: T.bool.isRequired,
  allowedToManageWorkflows: T.bool,
}

export default connect(state => ({
  featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
}))(injectIntl(AppLayout))
